<form [formGroup]="form" *ngIf="entity && form" class="mb-0" novalidate>
  <ng-container *ngIf="orientation === 'horizontal'">
    @if (templateForPermitForm) {
      <div>
        <wm-common-textfield
          [data]="{
            label:entity.label,
            id: entity.templateCode,
            type:'number',
            min:numericDE.minimumValue,
            max:numericDE.maximumValue,
            required:entity.isRequired,
            decimalPlaces:numericDE.decimalPlaces,
            step: stepValue,
            prefix: numericDE.type === NumericDataType.Currency ? '$' : '',
          }"
          [formControlName]="entity.templateCode"
          [ngModel]="entity.value ?? ''"
          (ngModelChange)="entity.value = $event ?? ''"
        ></wm-common-textfield>
      </div>
    }@else {
      <div class="form-group d-flex align-items-center" [ngClass]="{ 'mb-0': !showLabel }">
        <span
          *ngIf="showLabel"
          class="mr-3 mb-0 d-flex align-items-center"
          style="height: 38px;"
          [ngClass]="{ 'font-weight-bold': entity.isRequired }"
          >{{ entity.label }}</span
        >
        <div class="flex-shrink-0" style="width: 150px;">
          <div
            [ngClass]="
              numericDE.type === NumericDataType.Currency
                ? 'input-group'
                : numericDE.showUpDownButtons
                ? 'input-group'
                : ''
            "
          >
            <div
              *ngIf="numericDE.type === NumericDataType.Currency"
              class="input-group-prepend"
            >
              <span class="input-group-text">$</span>
            </div>
            <input
              type="text"
              class="form-control"
              [ngClass]="{ required: entity.isRequired }"
              [formControlName]="entity.templateCode"
              [(ngModel)]="entity.value"
              [name]="entity.templateCode"
              [id]="entity.templateCode"
              [min]="numericDE.minimumValue"
              [max]="numericDE.maximumValue"
              [required]="entity.isRequired"
              [wmNumberFormat]="numericDE.decimalPlaces"
              (keydown)="onKeyDown($event)"
            />
            <div
              *ngIf="numericDE.showUpDownButtons"
              class="input-group-append"
            >
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                style="padding: 2px 6px; font-size: 12px; line-height: 1;"
                (click)="incrementValue()"
                [disabled]="form.controls[entity.templateCode]?.disabled"
              >
                ▲
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                style="padding: 2px 6px; font-size: 12px; line-height: 1;"
                (click)="decrementValue()"
                [disabled]="form.controls[entity.templateCode]?.disabled"
              >
                ▼
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </ng-container>
  <ng-container *ngIf="orientation === 'vertical'">
    @if (templateForPermitForm) {
      <div>
        <wm-common-textfield
          [data]="{
            label:entity.label,
            type:'number',
            min:numericDE.minimumValue,
            max:numericDE.maximumValue,
            required:entity.isRequired,
            decimalPlaces:numericDE.decimalPlaces,
            step: stepValue,
            prefix: numericDE.type === NumericDataType.Currency ? '$' : '',
          }"
          [formControlName]="entity.templateCode"
          [ngModel]="entity.value ?? ''"
          (ngModelChange)="entity.value = $event ?? ''"
        ></wm-common-textfield>
      </div>
    }@else {
      <wm-de-label
        *ngIf="showLabel"
        [entity]="entity"
        [for]="entity.templateCode"
      ></wm-de-label>
      <div
        [ngClass]="
          numericDE.type === NumericDataType.Currency ? 'input-group mb-3' :
          numericDE.showUpDownButtons ? 'input-group mb-3' : ''
        "
      >
        <div
          *ngIf="numericDE.type === NumericDataType.Currency"
          class="input-group-prepend"
        >
          <span class="input-group-text">$</span>
        </div>
        <input
          type="text"
          class="form-control"
          [ngClass]="{ required: entity.isRequired }"
          [formControlName]="entity.templateCode"
          [(ngModel)]="entity.value"
          [name]="entity.templateCode"
          [id]="entity.templateCode"
          [min]="numericDE.minimumValue"
          [max]="numericDE.maximumValue"
          [required]="entity.isRequired"
          [wmNumberFormat]="numericDE.decimalPlaces"
          (keydown)="onKeyDown($event)"
        />
        <div
          *ngIf="numericDE.showUpDownButtons"
          class="input-group-append"
        >
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            style="padding: 2px 6px; font-size: 12px; line-height: 1;"
            (click)="incrementValue()"
            [disabled]="form.controls[entity.templateCode]?.disabled"
          >
            ▲
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            style="padding: 2px 6px; font-size: 12px; line-height: 1;"
            (click)="decrementValue()"
            [disabled]="form.controls[entity.templateCode]?.disabled"
          >
            ▼
          </button>
        </div>
      </div>
    }
  </ng-container>
</form>
